module.exports = __webpack_public_path__ + "img/bg2.2d7f65c9.png";